export default[
    {
        name: 'tShenBaoCaiLiao',
        path: 'tShenBaoCaiLiao',
        component: () => import('@/pages/BigData/TrademarkModule/TMmiddleDectail/tShenBaoCaiLiao'),
        meta: { title: '申报材料' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
    {
        name: 'tTongZhiWenShu',
        path: 'tTongZhiWenShu',
        component: () => import('@/pages/BigData/TrademarkModule/TMmiddleDectail/tTongZhiWenShu'),
        meta: { title: '通知文书' },
        props(route) {
            return {
                id: route.query.id
            }
        },
    },
]